module.exports = __webpack_public_path__ + "img/ads-404-icon.1e04d49c.svg";